/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqBrandModelResponseMonitoringSocialmediaPiracySocialMediaDetailPiracyResponse,
  MarqCommonProtocolFileResponse,
  MonitoringFilterProtocolResponse,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsCancelConfirmRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsExportCsvRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetDetailRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListResponse,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingCountRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingCountResponse,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingIdListRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingIdListResponse,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostConfirmRequest,
  MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostDismissRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class GenerativeAiPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyListingCountCreate
   * @request POST:/generative-ai/piracy/listing_count
   */
  piracyListingCountCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingCountResponse, any>({
      path: `/generative-ai/piracy/listing_count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyFilterPlatformList
   * @request GET:/generative-ai/piracy/filter/platform
   */
  piracyFilterPlatformList = (params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/generative-ai/piracy/filter/platform`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyFilterAssetList
   * @request GET:/generative-ai/piracy/filter/asset
   */
  piracyFilterAssetList = (params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/generative-ai/piracy/filter/asset`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyExportCsvCreate
   * @request POST:/generative-ai/piracy/export_csv
   */
  piracyExportCsvCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsExportCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/generative-ai/piracy/export_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyListCreate
   * @request POST:/generative-ai/piracy/list
   */
  piracyListCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListResponse, any>({
      path: `/generative-ai/piracy/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyListingIdListCreate
   * @request POST:/generative-ai/piracy/listing-id-list
   */
  piracyListingIdListCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingIdListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetListingIdListResponse, any>({
      path: `/generative-ai/piracy/listing-id-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyDetailCreate
   * @request POST:/generative-ai/piracy/detail
   */
  piracyDetailCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsGetDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqBrandModelResponseMonitoringSocialmediaPiracySocialMediaDetailPiracyResponse, any>({
      path: `/generative-ai/piracy/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyConfirmCreate
   * @request POST:/generative-ai/piracy/confirm
   */
  piracyConfirmCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostConfirmRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/generative-ai/piracy/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyDismissCreate
   * @request POST:/generative-ai/piracy/dismiss
   */
  piracyDismissCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsPostDismissRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/generative-ai/piracy/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GenerativeAiPiracy
   * @name PiracyCancelConfirmCreate
   * @request POST:/generative-ai/piracy/cancel-confirm
   */
  piracyCancelConfirmCreate = (
    data: MonitoringGenerativeaiPiracyGenerativeAiPiracyProtocolsCancelConfirmRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/generative-ai/piracy/cancel-confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
